/**
 * @author https://gitee.com/chu1204505056/vue-admin-better （不想保留author可删除）
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */

import Vue from 'vue'

import {
  getAccessToken,
  removeAccessToken,
  setAccessToken,
} from '@/utils/accessToken'
import { resetRouter } from '@/router'
import { login, getUserInfo } from '@/api/index'


const state = () => ({
  accessToken: getAccessToken(),
  username: '',
  avatar: '',
  permissions: [],
  userinfo: '',
  userId:''
})
const getters = {
  accessToken: (state) => state.accessToken,
  username: (state) => state.username,
  avatar: (state) => state.avatar,
  permissions: (state) => state.permissions,
  userinfo: (state) => state.userinfo,
  userId: (state) => state.userId,
}
const mutations = {
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
    setAccessToken(accessToken)
  },
  setUsername(state, username) {
    state.username = username
  },
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  setPermissions(state, permissions) {
    state.permissions = permissions
  },
  setUserinfo(state, data) {
    state.userinfo = data
  },
  setUserId(state, data) {
    state.userId = data
  },
}
const actions = {
  setPermissions({ commit }, permissions) {
    commit('setPermissions', permissions)
  },
  async login({ commit }, formdata) {
    const { data } = await login(formdata)
    commit('setAccessToken', data)
    console.log(data)
  },
  async getUserInfo({ commit, state }) {
    const { data } = await getUserInfo({ token: state.accessToken })
    if (!data) {
      console.error('验证失败，请重新登录...', 'error')
      return false
    }
    console.log('data:', data.user)
    commit('setUserinfo', data.user)
    commit('setUserId', data.user.userId)
  },
  async logout({ dispatch }) {
    await logout(state.accessToken)
    await dispatch('resetAccessToken')
    await resetRouter()
  },
  resetAccessToken({ commit }) {
    commit('setPermissions', [])
    commit('setAccessToken', '')
  },
}

export default { state, getters, mutations, actions }